import * as React from 'react'

import { connect } from 'react-redux'
import { Redirect, RouteComponentProps, withRouter } from 'react-router-dom'
import { compose } from 'redux'
import { _route } from 'routes/config'
import { AuthUser } from './withAuthentication'

export const withAuthorization = (
  condition: (_: any) => boolean,
  altRoute: string = '/',
  onRedirect: () => void = () => {
    return
  }
) => (Component: React.ElementType) => {
  interface INativeProps {}
  interface IReduxProps {
    user: any
    plus_user: any
    auth_user: {
      authUser: AuthUser
    }
  }
  interface IProps extends RouteComponentProps, INativeProps, IReduxProps {}
  interface IState {}

  class WithAuthorization extends React.Component<IProps, IState> {
    checkUser = () => {
      const { history, user, plus_user, auth_user } = this.props

      if (auth_user.authUser !== undefined && !condition({ user, plus_user })) {
        onRedirect()
        if (history.location.pathname !== altRoute) {
          history.replace(altRoute)
        }
      }
    }

    // AuthRedirect = (user, plusUser) => {
    //   // redirect to payment if not plus user and the route is not payment
    //   return (
    //     altRoute !== _route.payment &&
    //     !!user?.data &&
    //     !!user?.auth &&
    //     !!plusUser?.isPlusUser
    //   )
    // }

    componentDidMount() {
      this.checkUser()
    }

    componentDidUpdate() {
      this.checkUser()
    }

    render() {
      const { user, plus_user, auth_user } = this.props

      return auth_user.authUser !== undefined ? (
        condition({ user, plus_user }) ? (
          <Component {...this.props} />
        ) : (
          <Redirect to={altRoute} />
        )
      ) : (
        <></>
      )
    }
  }

  const withHOCs = compose(withRouter)(WithAuthorization)

  const mapStateToProps = state => ({
    user: state.user,
    plus_user: state.plus_user,
    auth_user: state.auth_user
  })
  const mapDispatchToProps = dispatch => ({})

  const Connected = connect(mapStateToProps, mapDispatchToProps)(withHOCs)

  return (props: INativeProps) => <Connected {...props} />
}



// WEBPACK FOOTER //
// ./src/components/Session/withAuthorization.tsx